module.exports = __webpack_public_path__ + "media/svg-new/icon-filter-a5946615.svg";